module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousVendorView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Container / Vehicle Gate-In Form")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "gateInType"
    }
  }, [_vm._v("Gate-In Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "gateTypeListV",
      "option-text": "gateTypeListT",
      "list": _vm.gateTypeList,
      "placeholder": "Select Type",
      "isDisabled": _vm.VehicleDetail.containerGateInId == '' ? false : true
    },
    model: {
      value: (_vm.ContainerDetail.gateInType),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "gateInType", $$v)
      },
      expression: "ContainerDetail.gateInType"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.gateInType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.gateInTypeError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Vehicle_With_Container') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerNo",
      "name": "containerNo",
      "disabled": _vm.ContainerDetail.containerGateInId == '' ? false : true
    },
    on: {
      "keyup": function($event) {
        _vm.checkContainer()
      }
    },
    model: {
      value: (_vm.ContainerDetail.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "containerNo", $$v)
      },
      expression: "ContainerDetail.containerNo"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.sameContainerError))]), _vm._v(" "), (!_vm.ContainerDetail.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerNoError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Container Size / Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "containerType",
      "option-text": "containerType",
      "list": _vm.containerDetail,
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ContainerDetail.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "containerTypeId", $$v)
      },
      expression: "ContainerDetail.containerTypeId"
    }
  }), _vm._v(" "), (!_vm.ContainerDetail.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerTypeIdError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ContainerDetail.gateInType != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "vehicleTruckId"
    }
  }, [_vm._v("Vehicle No.")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "regdNo",
      "option-text": "regdNo",
      "list": _vm.vehicleMasterList,
      "placeholder": "Select Vehicle",
      "disabled": _vm.ContainerDetail.containerTypeId == '' && _vm.ContainerDetail.gateInType != 'Empty_Vehicle' ? true : false
    },
    model: {
      value: (_vm.ContainerDetail.otherVehicle),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "otherVehicle", $$v)
      },
      expression: "ContainerDetail.otherVehicle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.sameVehicleError))]), _vm._v(" "), (!_vm.ContainerDetail.otherVehicle) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.otherVehicleError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.otherVehicle == 'Other Vehicle') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.otherVehicle == 'Other Vehicle') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Other Vehicle No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherVehicle",
      "name": "otherVehicle"
    },
    model: {
      value: (_vm.ContainerDetail.vehicleNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "vehicleNo", $$v)
      },
      expression: "ContainerDetail.vehicleNo"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.vehicleNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.vehicleNoError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ContainerDetail.gateInType != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transportName",
      "name": "transportName",
      "disabled": _vm.tempVehicle == _vm.ContainerDetail.otherVehicle ? true : false
    },
    model: {
      value: (_vm.ContainerDetail.transportName),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "transportName", $$v)
      },
      expression: "ContainerDetail.transportName"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.transportName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.transportNameError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Empty_Vehicle') ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    staticStyle: {
      "margin-top": "18px"
    },
    attrs: {
      "id": "addButtonLoader1"
    },
    on: {
      "click": _vm.addContainer
    }
  }, [_vm._v(_vm._s(_vm.ContainerDetail.containerGateInId == '' ? "Add" : "Edit") + " Vehicle")]) : _vm._e()], 1), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Vehicle_With_Container') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "importStatus"
    }
  }, [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "ImpVal",
      "option-text": "ImpText",
      "list": _vm.ImpList,
      "placeholder": "Select Type "
    },
    model: {
      value: (_vm.ContainerDetail.importStatus),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "importStatus", $$v)
      },
      expression: "ContainerDetail.importStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "list": _vm.lineDetailMaster,
      "placeholder": "Select Shipping Line "
    },
    model: {
      value: (_vm.ContainerDetail.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "shippingId", $$v)
      },
      expression: "ContainerDetail.shippingId"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Vehicle_With_Container') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight"
    },
    model: {
      value: (_vm.ContainerDetail.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "grossWeight", $$v)
      },
      expression: "ContainerDetail.grossWeight"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.grossWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.grossWeightError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tare Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tareWeight",
      "name": "tareWeight"
    },
    model: {
      value: (_vm.ContainerDetail.tareWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "tareWeight", $$v)
      },
      expression: "ContainerDetail.tareWeight"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.tareWeight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.tareWeightError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Mfg. Month-Yr")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manufractureYear",
      "name": "manufractureYear"
    },
    model: {
      value: (_vm.ContainerDetail.manufractureYear),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "manufractureYear", $$v)
      },
      expression: "ContainerDetail.manufractureYear"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.manufractureYear) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.manufractureYearError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerCondition"
    }
  }, [_vm._v("Container Condition")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "containerConditionV",
      "option-text": "containerConditionT",
      "list": _vm.containerConditionList,
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ContainerDetail.containerCondition),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "containerCondition", $$v)
      },
      expression: "ContainerDetail.containerCondition"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Vehicle_With_Container') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Arrival From")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "arrivalFrom",
      "name": "arrivalFrom"
    },
    model: {
      value: (_vm.ContainerDetail.arrivalFrom),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "arrivalFrom", $$v)
      },
      expression: "ContainerDetail.arrivalFrom"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Arrival date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehcleArrivalDate",
      "name": "vehcleArrivalDate",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.vehcleArrivalDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "vehcleArrivalDate", $$v)
      },
      expression: "ContainerDetail.vehcleArrivalDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Do Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "doNumber",
      "name": "doNumber"
    },
    model: {
      value: (_vm.ContainerDetail.doNumber),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "doNumber", $$v)
      },
      expression: "ContainerDetail.doNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("DO Valid upto Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "not-before": new Date(),
      "id": "bookingDate"
    },
    model: {
      value: (_vm.ContainerDetail.bookingDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "bookingDate", $$v)
      },
      expression: "ContainerDetail.bookingDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Vehicle_With_Container') ? _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-input-container', [_c('md-file', {
    attrs: {
      "placeholder": "Upload Do",
      "id": "transportName",
      "name": "transportName",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChange('uploadGateInCon')
      }
    },
    model: {
      value: (_vm.ContainerDetail.uploadGateInCon),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "uploadGateInCon", $$v)
      },
      expression: "ContainerDetail.uploadGateInCon"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.ContainerDetail.uploadGateInCon) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.uploadGateInConError))]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "85"
    }
  }), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Vehicle_With_Container') ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm",
      "id": "addButtonLoader1",
      "disabled": _vm.maintainenceId == '' ? false : true
    },
    on: {
      "click": _vm.addContainer
    }
  }, [_vm._v(_vm._s(_vm.ContainerDetail.containerGateInId == '' ? "Add" : "Edit") + " Container")]), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s((_vm.VehicleDetail.containerGateInId == '') ? _vm.containerGateInIdError : ""))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.allContainerDetail.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "box-title"
  }, [_vm._v("Container Detail")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "gateInContainer"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Container Number")]), _vm._v(" "), _c('th', [_vm._v("Container Size")]), _vm._v(" "), _c('th', [_vm._v("Arrival Date")]), _vm._v(" "), (_vm.maintainenceId == '') ? _c('th', [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.maintainenceId == '') ? _c('th', [_vm._v("Delete")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.allContainerDetail), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.containerNo == '') ? "-" : item.containerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((item.containerTypeId == '') ? "-" : item.containerTypeId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))]), _vm._v(" "), (_vm.maintainenceId == '') ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewModalPage(item.containerGateInId)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.maintainenceId == '') ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": (_vm.serviceDetails.approvedStatus == 'Sent For Approval')
      },
      on: {
        "click": function($event) {
          _vm.deleteData(item.containerGateInId)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1) : _vm._e()])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.gateInType == 'Vehicle_With_Container') ? _c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload DO")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload Images",
      "name": "uploadDriverDoc",
      "id": "uploadDriverDoc",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChange('Do')
      }
    },
    model: {
      value: (_vm.VehicleDetail.uploadDo),
      callback: function($$v) {
        _vm.$set(_vm.VehicleDetail, "uploadDo", $$v)
      },
      expression: "VehicleDetail.uploadDo"
    }
  })], 1), _vm._v(" "), (!_vm.VehicleDetail.uploadDo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.uploadImageError))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.viewDocument.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _vm._l((_vm.viewDocument), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "5"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/doGateIn/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("File - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "amountPaidYesNo"
    }
  }, [_vm._v("Amount Received(If Appilicable)")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "amountPaidYesNoV",
      "option-text": "amountPaidYesNoT",
      "list": _vm.amountPaidYesNoList,
      "placeholder": "Select As Appilicable"
    },
    model: {
      value: (_vm.VehicleDetail.amountPaidYesNo),
      callback: function($$v) {
        _vm.$set(_vm.VehicleDetail, "amountPaidYesNo", $$v)
      },
      expression: "VehicleDetail.amountPaidYesNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.VehicleDetail.amountPaidYesNo == 'Paid_In_Cash') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cashAmount",
      "name": "cashAmount"
    },
    model: {
      value: (_vm.VehicleDetail.cashAmount),
      callback: function($$v) {
        _vm.$set(_vm.VehicleDetail, "cashAmount", $$v)
      },
      expression: "VehicleDetail.cashAmount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.VehicleDetail.amountPaidYesNo == 'Paid_In_Cash') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Invoice/cheque No. (If Appilicable)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "cashAmountInvoice",
      "name": "cashAmountInvoice"
    },
    model: {
      value: (_vm.VehicleDetail.cashAmountInvoice),
      callback: function($$v) {
        _vm.$set(_vm.VehicleDetail, "cashAmountInvoice", $$v)
      },
      expression: "VehicleDetail.cashAmountInvoice"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remarks",
      "name": "remarks"
    },
    model: {
      value: (_vm.VehicleDetail.remarks),
      callback: function($$v) {
        _vm.$set(_vm.VehicleDetail, "remarks", $$v)
      },
      expression: "VehicleDetail.remarks"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.allContainerDetail.length > 0) ? _c('md-layout', {
    staticClass: "mrgtop-button",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "disabled": _vm.maintainenceId == '' ? false : true
    },
    on: {
      "click": _vm.addVehicleDetail
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop4",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose3
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopDo",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop3",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose3
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop11",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose3
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0852fd8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/yard/GateIn.vue
// module id = 2374
// module chunks = 0